// extracted by mini-css-extract-plugin
export var cartContainer = "_fv-4";
export var gray = "_fv-1";
export var itemContainer = "_fv-2";
export var itemDetails = "_fv-3";
export var strong = "_fv-0";